<template>
  <b-row class="match-height">
    <b-col lg="4" md="4">
      <card-advance-congratulation />
    </b-col>
    <b-col lg="8" md="8">
      <ecommerce-statistics :data="data.statisticsItems" />
    </b-col>
    <b-col lg="12" md="12" v-if="cekUser(userData)">
      <list-filter
        :satkerOptions="satkerOptions.options"
        @emitFilter="emitFilter"
        :dataFilter="dataFilter"
      />
    </b-col>
    <b-col md="6" sm="6" v-if="cekUser(userData)">
      <pagu-paket :rangePicker="rangePicker" :lineAreaChartSpline="datalineAreaChartSpline" />
    </b-col>
    <b-col lg="6" md="6" v-if="cekUser(userData)">
      <paket-sat-ker :barChart="dataPaketSatker" :rangePicker="rangePicker" />
    </b-col>
    <b-col lg="12" md="12" v-if="cekUser(userData)">
      <jenis-pengadaan-sumber-dana :dataOptionChart="optionChart" :key="reloadChart" />
    </b-col>
    <b-col lg="12" md="12" v-if="cekUserPemroses(userData)">
      <table-tiket-all
        :dataOptionChart="optionChart"
        :satkerOptions="satkerOptions.options"
        @emitFilter="emitFilter"
        :dataFilter="dataFilter"
      />
    </b-col>
  </b-row>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { BRow, BCol, BCard, BCardHeader, BCardBody, BCardSubTitle, BCardTitle } from 'bootstrap-vue'
import { getUPT, getDataStatistic } from '@/connection-api/master'
import AppEchartBar from '@core/components/charts/echart/AppEchartBar.vue'
import VueApexCharts from 'vue-apexcharts'
import flatPickr from 'vue-flatpickr-component'
import { $themeColors } from '@themeConfig'
import apexChatData from './apexChartData'
import CardAdvanceCongratulation from './CardAdvanceCongratulation.vue'
import EcommerceStatistics from './EcommerceStatistics.vue'
import PaguPaket from './PaguPaket.vue'
import PaketSatKer from './PaketSatKer.vue'
import JenisPengadaanSumberDana from './JenisPengadaanSumberDana.vue'
import TableTiketAll from './TableTiketAll.vue'
import listFilter from './listFilter.vue'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BRow,
    BCol,
    CardAdvanceCongratulation,
    EcommerceStatistics,
    PaguPaket,
    PaketSatKer,
    JenisPengadaanSumberDana,
    listFilter,
    TableTiketAll,
  },
  data() {
    return {
      satkerOptions: {
        selected: 'id',
        options: [{ value: null, label: 'Semua' }],
      },
      userData: JSON.parse(localStorage.getItem('userData')),
      indexSumberDana: {},
      dataFilter: {},
      dataPaketSatker: {},
      dataPaketPerMonth: {},
      dataPaguPerMonth: {},
      datalineAreaChartSpline: {},
      dataOptionChart: {},
      reloadChart: 0,
      lineAreaChartSpline: {
        series: [
          {
            name: 'Paket',
            type: 'column',
            // data: [100, 120, 90, 170, 130, 160, 140, 240, 220, 180, 90, 200],
          },
          {
            name: 'Pagu',
            type: 'line',
            // data: [20, 40, 30, 70, 40, 60, 50, 140, 120, 100, 140, 20],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
            type: 'line',
            height: 350,
          },
          dataLabels: {
            enabled: true,
            enabledOnSeries: [1],
          },
          stroke: {
            width: [0, 4],
          },
          legend: {
            show: true,
            position: 'top',
            horizontalAlign: 'left',
            fontSize: '14px',
            fontFamily: 'Montserrat',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          xaxis: {
            categories: [
              'Jan',
              'Feb',
              'Mar',
              'Apr',
              'Mei',
              'Jun',
              'Jul',
              'Agus',
              'Sep',
              'Okt',
              'Nov',
              'Des',
            ],
          },
          yaxis: {
            // opposite: isRtl
          },
          fill: {
            opacity: 1,
            type: 'solid',
          },
          tooltip: {
            shared: false,
          },
          // colors: [chartColors.area.series3, chartColors.area.series2, chartColors.area.series1],
        },
      },
      barChart: {
        series: [
          {
            // data: [700, 350, 480, 600, 210, 550, 150],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          colors: $themeColors.info,
          plotOptions: {
            bar: {
              horizontal: true,
              barHeight: '30%',
              endingShape: 'rounded',
            },
          },
          grid: {
            xaxis: {
              lines: {
                show: false,
              },
            },
          },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
            // categories: ['Sekretariat Daerah', 'Sekretariat DPRD', 'Inspektorat', 'Dinas Kependudukan dan Pencatatan Sipil', 'Dinas Kesehatan', 'Dinas Pendidikan', 'Dinas Tenaga Kerja, Sosial, dan Transmigrasi'],
          },
          yaxis: {
            // opposite: isRtl,
          },
        },
      },
      getData: {},
      data: {},
      satkerId: null,
      apexChatData,
      rangePicker: ['2021-05-01', '2021-12-10'],
      optionChart: {
        xAxis: [
          {
            type: 'value',
          },
        ],
        yAxis: [
          {
            type: 'category',
            data: [0, 0, 0, 0],
            splitLine: { show: false },
          },
        ],
        grid: {
          left: '100px',
          right: '30px',
          bottom: '30px',
        },
        series: [],
      },
    }
  },
  // created() {
  //   // data
  //   this.$http.get('/ecommerce/data')
  //     .then(response => {
  //       this.data = response.data
  //     })
  // },
  async created() {
    const response = await getUPT()
    this.mappingSelectOption(response.data, this.satkerOptions.options)

    this.reloadData()
  },
  methods: {
    cekUser(dataUser) {
      // if (dataUser.roles.indexOf('users') !== -1
      // || dataUser.roles.indexOf('koordinator') !== -1) {
      //   return false
      // }
      // return true

      if (dataUser.roles.indexOf('users') !== -1) {
        return false
      }
      return true
    },

    cekUserPemroses(dataUser) {
      // if (dataUser.roles.indexOf('users') !== -1
      // || dataUser.roles.indexOf('koordinator') !== -1) {
      //   return false
      // }
      // return true

      if (dataUser.roles.indexOf('users') !== -1) {
        return true
      }
      return false
    },
    reloadSplineChart(responseDS) {
      this.lineAreaChartSpline.series = [
        {
          name: 'Jumlah Konsultasi',
          type: 'column',
          data: responseDS.data.paketPerMonth,
        },
        {
          name: 'Selesai',
          type: 'line',
          data: responseDS.data.paguPerMonth,
        },
      ]
    },
    reloadOptionChart(responseDS) {
      this.optionChart = {
        xAxis: [
          {
            type: 'value',
          },
        ],
        yAxis: [
          {
            type: 'category',
            data: '',
            splitLine: { show: false },
          },
        ],
        grid: {
          left: '100px',
          right: '30px',
          bottom: '30px',
        },
        series: [],
      }
    },
    reloadBarChart(responseDS) {
      this.barChart.chartOptions = {
        chart: {
          toolbar: {
            show: false,
          },
        },
        colors: $themeColors.info,
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '30%',
            endingShape: 'rounded',
          },
        },
        grid: {
          xaxis: {
            lines: {
              show: false,
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: responseDS.data.kategoriSatKer,
        },
        yaxis: {
          // opposite: isRtl,
        },
      }
      this.barChart.series = [
        {
          data: responseDS.data.jumlahPaketSatker,
        },
      ]
    },
    async reloadData(dataFilter) {
      // this.$http.get('/ecommerce/data')
      //   .then(response => {
      //     this.data = response.data
      //     const array = this.data.statisticsItems
      //     const index = array.indexOf(3)
      //     array.splice(index, 3)
      //   })
      const responseDS = await getDataStatistic(dataFilter)
      this.data.statisticsItems = responseDS.data.status
      // console.log(responseDS.status)
      // this.data.statisticsItems[0].title = responseDS.data.perencanaan
      // this.data.statisticsItems[1].title = responseDS.data.paket
      // this.data.statisticsItems[2].title = responseDS.data.pagu
      // this.barChart.chartOptions.xaxis.categories = responseDS.data.kategoriSatKer

      this.reloadBarChart(responseDS)
      this.barChart.series[0].data = responseDS.data.jumlahPaketSatker
      this.lineAreaChartSpline.series[0].data = responseDS.data.paketPerMonth
      this.lineAreaChartSpline.series[1].data = responseDS.data.paguPerMonth

      this.reloadSplineChart(responseDS)
      // this.optionChart.series = responseDS.data.jenisPengadaan
      // this.optionChart.series[0].data = responseDS.data.jenisPengadaanSumberDana[0].data
      // this.optionChart.series[1].data = responseDS.data.jenisPengadaanSumberDana[1].data
      // this.optionChart.series[2].data = responseDS.data.jenisPengadaanSumberDana[2].data
      // this.optionChart.series[3].data = responseDS.data.jenisPengadaanSumberDana[3].data

      this.reloadOptionChart(responseDS)
      this.optionChart.yAxis[0].data = responseDS.data.jenisPengadaan
      this.optionChart.series = responseDS.data.jenisPengadaanSumberDana

      this.dataPaketSatker = this.barChart
      this.datalineAreaChartSpline = this.lineAreaChartSpline
      this.dataOptionChart = this.optionChart
      this.reloadChart += 1
    },
    emitFilter(data) {
      this.reloadData(data)
    },
    formatPrice(value) {
      const val = (value / 1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    mappingSelectOption(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
  },
}
</script>
<style type="text/css">
.echarts {
  width: 100% !important;
}
</style>
